import { EncounterMethodOutcome } from './EncounterMethodOutcome';
import { Enum, Selectable } from './Enum';

export class AppointmentStatus extends Enum {
  translationKey = 'appointmentStatus';

  static asArray: AppointmentStatus[] = [];

  static byKey: { [name: string]: AppointmentStatus } = {};

  static readonly CANC = new AppointmentStatus('CANC');

  static readonly CANCSMS = new AppointmentStatus('CANCSMS');

  static readonly COMP = new AppointmentStatus('COMP');

  static readonly CONF = new AppointmentStatus('CONF');

  static readonly CONFNOTST = new AppointmentStatus('CONFNOTST');

  static readonly CONFSMS = new AppointmentStatus('CONFSMS');

  static readonly CONFTESTED = new AppointmentStatus('CONFTESTED');

  static readonly CONN = new AppointmentStatus('CONN');

  static readonly KEPT = new AppointmentStatus('KEPT');

  static readonly N_S = new AppointmentStatus('N/S');

  static readonly PEN = new AppointmentStatus('PEN');

  static readonly R_S = new AppointmentStatus('R/S');

  static readonly UNC_LVM = new AppointmentStatus('UNC-LVM');

  static readonly UNC_SMS = new AppointmentStatus('UNC-SMS');

  static readonly UNCLVM_SMS = new AppointmentStatus('UNCLVM+SMS');

  static readonly VOID = new AppointmentStatus('VOID');

  static readonly VPC_CHKIN = new AppointmentStatus('VPC_CHKIN');

  static readonly VPC_CHKOUT = new AppointmentStatus('VPC_CHKOUT');

  static getStatusFromString(statusString?: string): Selectable | undefined {
    if (!statusString) return undefined;
    return AppointmentStatus.toSelectable().find(
      (option) => option.value === statusString,
    );
  }

  static toSelectable() {
    return Enum.toSelectable(Object.values(AppointmentStatus.byKey));
  }

  constructor(public readonly value: string) {
    super();
    AppointmentStatus.asArray.push(this);
    AppointmentStatus.byKey[value] = this;
  }

  static getColor(status?: string) {
    switch (status) {
      case EncounterMethodOutcome.SUCCESSFUL.toString():
      case EncounterMethodOutcome.TRANSFERRED.toString():
      case AppointmentStatus.COMP.toString():
      case AppointmentStatus.KEPT.toString():
      case AppointmentStatus.VPC_CHKOUT.toString():
        return 'success';
      case EncounterMethodOutcome.INVALID_EMAIL.toString():
      case EncounterMethodOutcome.INVALID_FAX_NUMBER.toString():
      case EncounterMethodOutcome.UNABLE_TO_CONNECT.toString():
      case AppointmentStatus.N_S.toString():
      case AppointmentStatus.R_S.toString():
      case AppointmentStatus.VOID.toString():
      case AppointmentStatus.CANC.toString():
      case AppointmentStatus.CANCSMS.toString():
      case undefined:
        return 'error';
      default:
        return 'warning';
    }
  }

  static readonly RESCHEDULE_NEEDED_STATUSES = [
    AppointmentStatus.CANC,
    AppointmentStatus.CANCSMS,
    AppointmentStatus.N_S,
    AppointmentStatus.R_S,
    AppointmentStatus.VOID,
  ];

  static readonly COMPLETED_STATUSES = [
    AppointmentStatus.COMP,
    AppointmentStatus.KEPT,
    AppointmentStatus.VPC_CHKOUT,
  ];

  static readonly PENDING_STATUSES = [
    AppointmentStatus.PEN,
    AppointmentStatus.CONF,
    AppointmentStatus.CONFSMS,
    AppointmentStatus.CONFTESTED,
    AppointmentStatus.CONFNOTST,
    AppointmentStatus.CONN,
    AppointmentStatus.UNCLVM_SMS,
    AppointmentStatus.UNC_LVM,
    AppointmentStatus.UNC_SMS,
    AppointmentStatus.VPC_CHKIN,
  ];
}

export default AppointmentStatus;
